export const CREATE_ERROR_MAPPINGS = {
    "process_name_unique": 'work_flow.api_error.process_name_unique',
    "process_name_blank": 'work_flow.api_error.process_name_blank',
    "required_fields_missing": 'work_flow.api_error.required_fields_missing',
    "invalid_field_group_ids": 'work_flow.api_error.invalid_field_group_ids',
    "invalid_role_ids": 'work_flow.api_error.invalid_role_ids',
    "practice_null":'work_flow.api_error.practice_null',
    "sequence_number_not_allowed":'work_flow.api_error.sequence_number_not_allowed',
    "sequence_number_is_required":'work_flow.api_error.sequence_number_is_required',
    "workflow_name_already_exists":'work_flow.api_error.workflow_name_already_exists',
    "sequence_number_already_exist":'work_flow.api_error.sequence_number_already_exist',
    "prcatice_is_required":'work_flow.api_error.practice_null',
    "process_name_required":'work_flow.api_error.process_name_blank',
    "atleast_one_role_or_field_group_must_be_configured":'work_flow.api_error.atleast_one_role_or_field_group_must_be_configured',
    "process_name_max_length":'work_flow.api_error.process_name_max_length',
    "auditing_workflow_is_system_managed_and_cannot_be_created_manually":'work_flow.api_error.auditing_workflow_is_system_managed_and_cannot_be_created_manually'
};

export const UPDATE_ERROR_MAPPINGS = {
    "process_name_unique": 'work_flow.api_error.process_name_unique',
    "process_name_blank": 'work_flow.api_error.process_name_blank',
    "required_fields_missing": 'work_flow.api_error.required_fields_missing',
    "invalid_field_group_ids": 'work_flow.api_error.invalid_field_group_ids',
    "invalid_role_ids": 'work_flow.api_error.invalid_role_ids',
    "practice_null":'work_flow.api_error.practice_null',
    "sequence_number_not_allowed":'work_flow.api_error.sequence_number_not_allowed',
    "sequence_number_is_required":'work_flow.api_error.sequence_number_is_required',
    "workflow_name_already_exists":'work_flow.api_error.workflow_name_already_exists',
    "prcatice_is_required":'work_flow.api_error.practice_null',
    "process_name_required":'work_flow.api_error.process_name_blank',
    "atleast_one_role_or_field_group_must_be_configured":'work_flow.api_error.atleast_one_role_or_field_group_must_be_configured',
    "process_name_max_length":'work_flow.api_error.process_name_max_length',
    "auditing_workflow_is_system_managed_and_cannot_be_created_manually":'work_flow.api_error.auditing_workflow_is_system_managed_and_cannot_be_created_manually'
};

export const CREATE_DEFAULT_ERROR = 'work_flow.common_message.create_failed_response';

export const UPDATE_DEFAULT_ERROR = 'work_flow.common_message.update_failed_response';

export const DELETE_DEFAULT_ERROR = 'work_flow.common_message.delete_failed_response';